import { useEffect, useState } from 'react'

/**
 * نقطه‌شکست، از راه جاوااسکریپت
 * ==============================
 * روش معمولِ «دو چیدمان، یکی `md:hidden` و یکی `hidden md:block`» برای محتوای
 * ساده بی‌عیب است: فقط یکی دیده می‌شود.
 *
 * ولی وقتی هر دو چیدمان کامپوننت‌های **زنده** دارند — نمودار قیمت، دفتر
 * سفارش، فهرستی که هر چند ثانیه به‌روز می‌شود — هر دو نسخه واقعاً سوار
 * می‌شوند: دو نمونه نمودار، دو اشتراک قیمت، دو تایمر. کاربر یکی را می‌بیند و
 * باتری‌اش خرج هر دو می‌شود.
 *
 * این قلاب اجازه می‌دهد فقط یکی از دو درخت ساخته شود.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false,
  )

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mql = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    // مقدار اولیه را دوباره می‌خوانیم: ممکن است بین رندر اول و این افکت،
    // چرخش صفحه رخ داده باشد.
    setMatches(mql.matches)
    // سافاری قدیمی addEventListener روی MediaQueryList ندارد
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    }
    const legacy = mql as unknown as { addListener: (fn: any) => void; removeListener: (fn: any) => void }
    legacy.addListener(onChange)
    return () => legacy.removeListener(onChange)
  }, [query])

  return matches
}

/** ≥ ۱۲۸۰px — همان نقطه‌ای که چیدمان سه‌ستونه معامله معنا پیدا می‌کند (xl تیلویند) */
export const useIsDesktop = () => useMediaQuery('(min-width: 1280px)')
